import { useIntl } from 'react-intl';

import { OrderStatusData } from '#components/shared/OrderStatusData.ts';
import type { OrderStatus } from '#domain/Order.ts';

type OrderStateProps = { status: OrderStatus };

export const OrderState = ({ status }: OrderStateProps) => {
    const intl = useIntl();
    const { color, icon, id } = OrderStatusData[status];

    return (
        <span className='white-space-nowrap'>
            <span className={`label label-${color}`}>
                <span className='display-flex align-items-center gap-5'>
                    <span className={`uikit-icon icon-${icon}`} />
                    <span>{intl.formatMessage({ id })}</span>
                </span>
            </span>
        </span>
    );
};
